import { Option } from '~/shared/config/constants'
import { useParserI18nMessage } from '~/shared/lib/useParserI18nMessage'
import { ChipDelete } from '~/shared/ui/Chips'

type InternalChipListProps<T extends Option> = {
  values: T[]
  onChange: (values: T[]) => void
  disabled?: boolean
}

export function InternalChipList<T extends Option>({
  values,
  onChange,
  disabled,
}: InternalChipListProps<T>) {
  const { parserI18nMessage } = useParserI18nMessage()

  return (
    <>
      {values.map((value) => (
        <ChipDelete
          key={value.id}
          onDelete={() => {
            const filteredValues = values.filter((v: T) => v.id !== value.id)
            onChange(filteredValues)
          }}
          disabled={disabled}
        >
          {parserI18nMessage(value.label)}
        </ChipDelete>
      ))}
    </>
  )
}
